import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { PenIcon, FileTextIcon } from './Icons';
import AuthorPermissionModal from './AuthorPermissionModal';

const CreateContentModal = ({ isOpen, onClose, onCreateIdea, onCreateArticle }) => {
  const navigate = useNavigate();
  const { user, isAuthenticated, checkAuthorProfile } = useAuth();
  const [showPermissionModal, setShowPermissionModal] = React.useState(false);

  if (!isOpen) return null;

  const handleCreateIdea = () => {
    onClose();
    onCreateIdea();
  };

  const handleCreateArticle = () => {
    // 检查用户是否已登录
    if (!isAuthenticated) {
      alert('请先登录后再创建文章');
      onClose();
      navigate('/login');
      return;
    }

    // 检查用户是否有author权限
    if (!checkAuthorProfile()) {
      setShowPermissionModal(true);
      return;
    }

    // 如果有权限，执行创建文章逻辑
    if (onCreateArticle) {
      onCreateArticle();
    } else {
      onClose();
      navigate('/create-article');
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="create-content-modal" onClick={e => e.stopPropagation()}>
        <div className="create-content-header">
          <h3>开始创作</h3>
          <button className="modal-close" onClick={onClose}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        <div className="create-content-body">
          <div className="create-content-grid">
            <button className="create-option-card" onClick={handleCreateIdea}>
              <div className="create-option-icon">
                <PenIcon size={24} />
              </div>
              <h4>片语</h4>
            </button>

            <button className="create-option-card" onClick={handleCreateArticle}>
              <div className="create-option-icon">
                <FileTextIcon size={24} />
              </div>
              <h4>文章</h4>
            </button>
          </div>
        </div>
      </div>

      {/* Author权限提示模态框 */}
      <AuthorPermissionModal
        isOpen={showPermissionModal}
        onClose={() => setShowPermissionModal(false)}
        user={user}
      />
    </div>
  );
};

export default CreateContentModal;